<section class="bauherr-placeholder">
  <h2>Bauherr Dashboard</h2>
  <p>Dieser Workspace ist als Erweiterungspunkt reserviert und wird spaeter aus mehreren Bautagebuechern aufgebaut.</p>
</section>
